import { UserFilter } from '@shared/interfaces/user.interface';

export default function getFilterKey(filter: UserFilter): string {
  return JSON.stringify(filter || {});
}
